<template>
  <Dialog :title="$t('Duplicar cita')" v-model="show">
    <!-- Contenido del Dialog, Formulario -->
    <template v-slot:content>
      <ValidationObserver ref="validationObserver">
        <v-form ref="form" lazy-validation class="pa-1">
          <v-row>
            <v-col cols="12">
              {{ $t('Añade las fechas donde se duplicará la cita') }}
              <v-btn
                  fab
                  x-small
                  color="primary"
                  @click="add_date"
              >
                <v-icon dark>
                  mdi-plus
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row
              v-for="(_, index) in dates"
              :key="index"
          >
            <v-col cols="10">
              <ValidationProvider rules="required"
                                  :name="$t('Fecha').toLowerCase()"
                                  v-slot="{ errors, classes }"
              >
                <div class="control" :class="classes">

                  <DatePicker
                      title="Fecha"
                      v-model="dates[index]"
                      :outlined="true"
                      :dense="true"
                      :hide_details="true"
                  />
                </div>
                <span class="error--text">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>
            <v-col cols="2">
              <v-btn
                  fab
                  x-small
                  color="red"
                  @click="delete_date(index)"
              >
                <v-icon color="white">
                  mdi-delete
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </ValidationObserver>
    </template>
    <!-- Acciones de la derecha del dialog -->
    <template v-slot:right-action>
      <v-btn @click="save" small class="primary">
        <v-icon small>mdi-content-save</v-icon>
        {{  $t("Guardar") }}
      </v-btn>
    </template>
  </Dialog>
</template>

<script>
import {ValidationProvider, ValidationObserver} from 'vee-validate';

export default {
  name: "FormDuplicarCita",
  props: ['value', 'id_cita'],

  data: () => ({
    dates: [],
  }),

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {

    /**
     * Llama a la api para generar las nuevas citas
     */
    async save() {
      const form_valid = await this.$refs.validationObserver.validate()
      if (form_valid) {
        try {
          await this.$store.dispatch('cita/duplicate_cita', {
            id: this.id_cita,
            dates: this.dates
          })
	        this.$snotify.success(
		        this.$t("Acción realizada con éxito"),
		        this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
	        )
          this.$emit('on_save')
        } catch (err) {
	        this.$snotify.error(
		        this.$t("Ha ocurrido un error"),
		        this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
	        )
        }
      }
    },


    /**
     * Añade una fecha
     */
    add_date() {
      const today = this.$moment().format('YYYY-MM-DD')
      this.dates.push(today);
    },

    /**
     * Elimina una fecha
     * @param index
     */
    delete_date(index) {
      this.dates.splice(index, 1);
    },
  },

  mounted() {
  },

  components: {
    ValidationProvider,
    ValidationObserver
  }
}
</script>